import axios from "axios";
import Api from "../../../../https/Api";

export interface ITouristGuide {
    _id?: string;
    preview: any;
    file: any;
    title: string;
    description: string;
    pdfUrl?: string; // Add pdfUrl property
}

export class GuideService {
    private api: Api;
    constructor() {
        this.api = new Api();
    }

    async create(guide: ITouristGuide) {
        return this.api.post("touristGuides", guide);
    }

    async uploadFile(id: any, property: any) {
        return this.api.postFile(`touristGuides/uploadFiles`, id, property);
    }

    async getAllGuide() {
        return this.api.get(`touristGuides`);
    }

    async editGuide(id: any, inputData: any) {
        return this.api.put(`touristGuides/update/${id}`, inputData);
    }

    async getGuide(id: any) {
        return this.api.get(`touristGuides/get/${id}`);
    }

    async deleteGuide(id: any) {
        return this.api.delete(`touristGuides/delete/${id}`);
    }

    async deleteAllGuide(ids: string[]) {
        const paramsId = {
            ids: ids,
        };
        return this.api.deleteMany(`touristGuides/deleteMany`, paramsId);
    }

    async downloadFile(id: any) {
        return this.api.downloadFileIFrame(`touristGuides/downloadFile/${id}`);
    }

    static getGuideById(id: string) {
        return axios.get(`/touristGuides/get/${id}`);
      }
}
